import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-ink px-5 py-16 text-white md:py-24" aria-labelledby="testimonials-title" data-id="element-324" data-mp="3fznrfeogiyy7">
      <div className="mx-auto max-w-6xl" data-id="element-325" data-mp="3b0uf3pkwpdzm">
        <div className="mx-auto max-w-3xl text-center" data-id="element-326" data-mp="3azt4tnbpsviy">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-gold" data-id="element-327" data-mp="36yppd1xkx1i9">What Healthcare Professionals Are Saying</p>
          <h2 id="testimonials-title" className="mt-3 font-display text-3xl font-black leading-tight md:text-5xl" data-id="element-328" data-mp="31zmqjz86zriq">
            A Clinical Reference Should Make Information Easier to Organize and Use
          </h2>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-329" data-mp="2s39skp5m6ri6">
          {testimonials.map((t, i) => <li key={t.name} className={`flex flex-col rounded-3xl bg-navy p-6 ${i === 0 ? 'md:col-span-2 lg:col-span-1 lg:row-span-2' : ''}`} data-id="element-330" data-mp="v7c8jc02nfs1" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-331" data-mp="h4n3caflzxae">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-332" data-mp="780mrxubfse6" data-mpi={s} />)}
              </div>
              <blockquote className={`mt-4 leading-relaxed text-slate-100 ${i === 0 ? 'text-xl font-medium lg:text-2xl' : 'text-[17px]'}`} data-id="element-333" data-mp="c7wnno7pv3pi">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-334" data-mp="14uhe8mgdbbs0">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand" loading="lazy" data-id="element-335" data-mp="q6wbwurbhgl5" />
                <div data-id="element-336" data-mp="1iu90fah1fyh3">
                  <p className="font-bold text-white" data-id="element-337" data-mp="1itqybx7p2q19">{t.name}</p>
                  <p className="text-sm text-slate-400" data-id="element-338" data-mp="1nma78gvfswzq">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <SectionCTA label="Join Them — Get TRT Blueprint Now" dark data-id="element-339" data-mp="1xfwkywr5l50h" />
      </div>
    </section>;
}